module.exports = function date_from_now(input) {
  return window.moment(input).fromNow()
}
